import { render } from "./view-underwritter.vue?vue&type=template&id=01da0112&lang=html"
import script from "./view-underwritter.vue?vue&type=script&lang=js"
export * from "./view-underwritter.vue?vue&type=script&lang=js"

import "./view-underwritter.vue?vue&type=style&index=0&id=01da0112&lang=less"

import exportComponent from "/opt/nexus/frontend/v1/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__